import { format } from 'date-fns';

import ruLocale from 'date-fns/locale/ru';

export function formatDate(date: number | Date, dateFormat: string) {
    return format(date, dateFormat, { locale: ruLocale });
}
